module.exports = __webpack_public_path__ + "static/media/back.2a814080.svg";